const internetConnectionTypeEnum = Object.freeze({
  PPPOE: 1,
  DYNAMIC: 2,
  STATIC: 3,
  HOTSPOT: 4,
})

export default internetConnectionTypeEnum
